const DOCUMENT = 'POSITION_';

const actions = {
  ADD: DOCUMENT + 'ADD',
  CANCEL: DOCUMENT + 'CANCEL',
  CHANGE_NESTED_PROPERTY: DOCUMENT + 'CHANGE_NESTED_PROPERTY',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CREATE: DOCUMENT + 'CREATE',
  EDIT: DOCUMENT + 'EDIT',
  LOAD: DOCUMENT + 'LOAD',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_FORM_DATA_ERROR: DOCUMENT + 'LOAD_FORM_DATA_ERROR',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_FAIL: DOCUMENT + 'SAVE_FAIL',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  TOUCH: DOCUMENT + 'TOUCH',

  add: data => ({ type: actions.ADD, payload: data }),
  cancel: () => ({ type: actions.CANCEL }),
  changeNestedProperty: data => ({ type: actions.CHANGE_NESTED_PROPERTY, payload: data }),
  changeProperty: data => ({ type: actions.CHANGE_PROPERTY, payload: data }),
  clearStore: () => ({ type: actions.CLEAR_STORE }),
  create: () => ({ type: actions.CREATE }),
  edit: data => ({ type: actions.EDIT, payload: data }),
  loadData: data => ({ type: actions.LOAD, payload: data }),
  loadFormData: () => ({ type: actions.LOAD_FORM_DATA }),
  loadFormDataError: () => ({ type: actions.LOAD_FORM_DATA_ERROR }),
  loadFormDataSuccess: data => ({ type: actions.LOAD_FORM_DATA_SUCCESS, payload: data }),
  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),
  save: data => ({ type: actions.SAVE, payload: data }),
  saveFail: data => ({ type: actions.SAVE_FAIL, payload: data }),
  saveSuccess: data => ({ type: actions.SAVE_SUCCESS, payload: data }),
  touch: data => ({ type: actions.TOUCH, payload: data }),
};

export default actions;
